const setDateToCurrentYear = date => date.setFullYear(new Date().getFullYear());

const addOneDay = date => date.setHours(date.getHours() + 24);

module.exports = {
  setDateToCurrentYear,
  addOneDay,
};



// WEBPACK FOOTER //
// ./src/pages/helpers/dateHelpers.js